export default __webpack_public_path__ + "images/cash.2ec2ecdc.svg";